export default {
  LOCAL: 'local',
  VPN: 'vpn',
  CLOUD: 'cloud',
}
